import { isMatch } from "date-fns";

// eg 2023-12-31
export const DATE_FORMAT = "yyyy-MM-dd";

export const validateDateFormat = (date: string) => {
  if (date === "") {
    return "";
  }

  if (isMatch(date, DATE_FORMAT)) {
    return date;
  }

  throw Error(
    `DatePicker defaultValue '${date}' is invalid. The expected format is '${DATE_FORMAT}' `,
  );
};
